export const DELETED_MAPS_FETCH_DATA_REQUEST = 'DELETED_MAPS/FETCH_DATA_REQUEST';
export const DELETED_MAPS_FETCH_DATA_ERROR = 'DELETED_MAPS/FETCH_DATA_ERROR';
export const ALL_UNDO_ITEMS_FETCH_DATA_SUCCESS = 'ALL_UNDO_ITEMS/FETCH_DATA_SUCCESS';
export const DELETE_UNDO_ITEM = 'DELETE_MAPS/UNDO_ITEM';

export const SPREADSHEET_VERSIONS_ROLLBACK = 'SPREADSHEET_VERSIONS/ROLLBACK';
